import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';

import { HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { map } from 'rxjs/operators';
import { Favorite } from '../models/auth/_models/favorite';
import { AuthService } from '../models/auth/_services/auth.service';
import { ActionResult } from '../models/auth/_models/action-result';
import { MessagesService } from './service.index';




@Injectable({
  providedIn: 'root'
})
export class FavoritesService {
  favorites$: BehaviorSubject<Favorite[]> = new BehaviorSubject<Favorite[]>(null);
  constructor(private http: HttpClient, private configService: ConfigService,  private messagesService: MessagesService, private auth:AuthService) { }

  getFavorites(companyCode:number) {
    this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/Favorites?companyCode=${companyCode}`).subscribe(resp => {
      let data: Favorite[] = [];
      if (resp.isSuccessful && resp.result != null) {
        for (let favoriteBd of resp.result) {
          let favorite: any = {
            aud_esta: favoriteBd.auD_ESTA,
            aud_ufac: favoriteBd.auD_UFAC,
            aud_usua: favoriteBd.auD_USUA,
            fav_cont: favoriteBd.faV_CONT,
            fav_maid: favoriteBd.faV_MAID,
            usu_codi: favoriteBd.usU_CODI,

          };
          data.push(favorite);
        }
      }

      this.favorites$.next(data);
    }, err => this.messagesService.error("Error cargando favoritos: No se puedo conectar con el servidor"))


  }
  addFavorite(favorite: Favorite) {
    this.http.post<ActionResult<string>>(`${this.configService.config.apiSecuritySeven}/Favorites`, favorite).subscribe(resp => {
      if (resp.isSuccessful) {
        this.messagesService.success('Favorito agregado');
        this.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
      }
      else
        this.messagesService.error(`Error agregando favorito: ${resp.errorMessage}`);
    }, err => this.messagesService.error(`Error agregando favorito: No se puedo conectar con el servidor`));
  }
  deleteFavorite(id: any) {
    this.http.get<ActionResult<any[]>>(`${this.configService.config.apiSecuritySeven}/Favorites/Delete?id=${id}`).subscribe(resp => {
      if (resp.isSuccessful) {
        this.messagesService.success('Favorito eliminado');
        this.getFavorites(Number(this.auth.currentUserValue.selectedCompany.code));
      }
      else
        this.messagesService.error(`${resp.errorMessage}`);
    }, err => this.messagesService.error(`Error eliminando favorito: No se puedo conectar con el servidor`));
  }
}
